import React, { useMemo, useState } from "react";
import { ArrowsClockwise, Copy, TextAa } from "@phosphor-icons/react";
import {
  Button,
  Group,
  Stack,
  Switch,
  Text,
  Textarea,
} from "@mantine/core";

function convertSentenceCase(value: string): string {
  const sentences = value.split(".").map((sentence) => {
    const trimmed = sentence.trim();
    if (trimmed.length === 0) return "";
    const firstChar = trimmed.charAt(0).toLocaleUpperCase("tr-TR");
    const rest = trimmed.slice(1).toLocaleLowerCase("tr-TR");
    return firstChar + rest;
  });
  const result = sentences.filter(Boolean).join(". ");
  return value.endsWith(".") ? `${result}.` : result;
}

function convertTitleCase(value: string): string {
  return value
    .split(" ")
    .map((word) => {
      if (!word) return word;
      return (
        word.charAt(0).toLocaleUpperCase("tr-TR") +
        word.slice(1).toLocaleLowerCase("tr-TR")
      );
    })
    .join(" ");
}

export default function TrCaseConverterPage() {
  const [inputValue, setInputValue] = useState("");
  const [titleCaseMode, setTitleCaseMode] = useState(false);

  const outputValue = useMemo(() => {
    if (!inputValue.trim()) return "";
    return titleCaseMode
      ? convertTitleCase(inputValue)
      : convertSentenceCase(inputValue);
  }, [inputValue, titleCaseMode]);

  const copyOutput = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(outputValue);
    } catch (error) {
      console.error("Kopyalama başarısız:", error);
    }
  };

  return (
    <div className="tool-page">
      <div className="tool-glass-panel">
        <Stack gap="md">
          <Group justify="space-between">
            <div className="tool-page-title">
              <TextAa size={28} weight="duotone" />
              <Text fw={600} size="lg">Türkçe Kelime Dönüştürücü</Text>
            </div>
            <Switch
              checked={titleCaseMode}
              onChange={(event) => setTitleCaseMode(event.currentTarget.checked)}
              label="Baş Harfleri Büyüt"
            />
          </Group>

          <Textarea
            value={inputValue}
            onChange={(event) => setInputValue(event.currentTarget.value)}
            onKeyDown={(event) => {
              if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
                event.preventDefault();
                if (outputValue) copyOutput();
              }
            }}
            minRows={7}
            autosize
            label="Girdi Metni"
            placeholder="Metni buraya yaz... (⌘/Ctrl + Enter ile kopyala)"
            autoFocus
          />

          <Textarea
            value={outputValue}
            readOnly
            minRows={7}
            autosize
            label="Dönüştürülmüş Metin"
            placeholder="Sonuç burada görünecek..."
          />

          <Group justify="flex-end">
            <Button
              variant="default"
              leftSection={<ArrowsClockwise size={16} />}
              onClick={() => setInputValue("")}
            >
              Temizle
            </Button>
            <Button
              onClick={copyOutput}
              disabled={!outputValue}
              leftSection={<Copy size={16} />}
            >
              Kopyala
            </Button>
          </Group>
        </Stack>
      </div>
    </div>
  );
}
